exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".attribute-element[data-v-863f60b6]{display:-ms-flexbox;display:flex;border:1px solid #000;-ms-flex-align:center;align-items:center}.attribute-element .label[data-v-863f60b6]{border-right:1px solid #000;padding:4px;min-width:100px;background-color:dimgray;color:#fff}.attribute-element .data[data-v-863f60b6]{width:100%;padding-left:6px;padding-top:2px}.result-area[data-v-863f60b6]{margin-top:2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-863f60b6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DoublesAcceptance.vue
// module id = 472
// module chunks = 0